import { Button, Typography } from "antd";

export default function RevenuePeriodSelector({
  selectedPeriod,
  setSelectedPeriod,
}) {
  const { Text } = Typography;
  return (
    <div
      style={{
        marginBottom: 16,
        textAlign: "left",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
      }}>
      <Text strong>Período de agregação:</Text>
      <Button
        type={selectedPeriod === "day" ? "primary" : "default"}
        onClick={() => setSelectedPeriod("day")}>
        Dia
      </Button>
      <Button
        type={selectedPeriod === "week" ? "primary" : "default"}
        onClick={() => setSelectedPeriod("week")}>
        Semana
      </Button>
      <Button
        type={selectedPeriod === "month" ? "primary" : "default"}
        onClick={() => setSelectedPeriod("month")}>
        Mês
      </Button>
    </div>
  );
}
